
























import Vue from "vue";
import Component from "vue-class-component";

import { Event } from "../../types";

@Component
export default class ImportDeckFromURL extends Vue {
  chosenURL = "";
  fileContent = "";
  urlRules = [
    (value: string) =>
      new RegExp("^https://.*/.*.json$").exec(value) !== null ||
      "Please provide a correct URL"
  ];
  async loadFileFromURL() {
    try {
      const response = await fetch(this.chosenURL);
      const fileContent = await response.json();
      this.$eventHub.$emit(Event.ADD_DECKS_FROM_JSON, fileContent, this.chosenURL);
    } catch (error) {
      // console.log(error);
      // TODO: cors?!
      this.$eventHub.$emit(
        Event.SNACKBAR_EVENT,
        "An error occurred while loading the file"
      );
    }
  }
}
